<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Elfelejtett jelszó') }}</h1>

        <p class="mb-16 text-center text-sm">
            {{ __('Írd be a fiókodhoz tartozó email címet ahova küldünk majd egy emailt a jelszó visszaállításához szükséges utasításokkal.') }}
        </p>

        <div class="flex flex-col items-center md:w-1/2 mx-auto">
            <c-control-text class="mb-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                            v-bind:invalid="!!requestStore.errors?.email"
                            v-bind:label="__('E-mail cím')"
                            v-bind:placeholder="__('placeholders.email')"
                            v-model="email"
            />

            <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 normal-case px-4 py-2 rounded-none text-center !text-lg text-white transition-colors w-48"
                      v-on:click="submit"
            >
                {{ __('Új jelszót kérek') }}
            </c-button>

            <span class="flex text-sm">
                {{ __('Van már fiókod?') }}
                <router-link class="block underline ml-1 text-highlight"
                             v-bind:to="{ name : 'login' }">
                    {{ __('Jelentkezz be') }}
                </router-link>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlText,
    } from '@teamfurther/cinderblock';
    import { useRequestStore }  from '../../stores/request';
    import { useSessionStore }  from '../../stores/session';

    const email = ref('');
    const requestStore = useRequestStore();
    const sessionStore = useSessionStore();

    async function submit() {
        await sessionStore.sendPasswordReset(email.value);
    }

    onMounted(() => {
        if (sessionStore.user) {
            requestStore.redirect({ name: 'errors.403' });
        }

        const route = useRoute();

        if (route.query.email) {
            email.value = route.query.email as string;
        }
    });
</script>
